// @ts-strict-ignore
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import { type IFetchReportPayload, type IReportRequest, ReportRequestName } from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchActivity(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.Activity,
      interface: ApiManager.reportApi.fetchAgentActivity,
    },
  ];

  yield makeFetchingSaga(ReportType.Activity, action, requests);
}
